import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../modules/auth/store/reducer';
import meReducer from '../modules/me/store/reducer';
import globalReducer from '../modules/global/store/reducer';
import companyReducer from '../modules/company/store/reducer';
import userReducer from '../modules/user/store/reducer';
import metricsReducer from '../modules/metrics/store/reducer';
import metricsConfigReducer from '../modules/metrics_config/store/reducer';
import reportsReducer from '../modules/reports/store/reducer';
import alertsReducer from '../modules/alerts/store/reducer';

const reducers = () =>
  combineReducers({
    alerts: alertsReducer,
    auth: authReducer,
    company: companyReducer,
    global: globalReducer,
    me: meReducer,
    metrics: metricsReducer,
    metrics_config: metricsConfigReducer,
    reports: reportsReducer,
    user: userReducer,
  });

export default reducers;
